import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { LoadingComponent } from '@components/loading/loading.component';
import { PhoneOrderUserBannerComponent } from '@components/phone-order-user-banner/phone-order-user-banner.component';
import { Sites } from '@enums/sites';
import { environment } from '@environments/environment';
import { AnalytehealthLayoutComponent } from '@layout/analytehealth-layout/analytehealth-layout.component';
import { HealthlabsLayoutComponent } from '@layout/healthlabs-layout/healthlabs-layout.component';
import { StallionLayoutComponent } from '@layout/stallion-layout/stallion-layout.component';
import { StarfishLayoutComponent } from '@layout/starfish-layout/starfish-layout.component';
import { StdcheckLayoutComponent } from '@layout/stdcheck-layout/stdcheck-layout.component';
import { TestosteroneHqLayoutComponent } from '@layout/testosterone-hq-layout/testosterone-hq-layout.component';
import { TreatmyutiLayoutComponent } from '@layout/treatmyuti-layout/treatmyuti-layout.component';
import { LoadingService } from '@services/loading.service';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgIf,
    HealthlabsLayoutComponent,
    LoadingComponent,
    NgTemplateOutlet,
    PhoneOrderUserBannerComponent,
    StdcheckLayoutComponent,
    TreatmyutiLayoutComponent,
    StallionLayoutComponent,
    StarfishLayoutComponent,
    TestosteroneHqLayoutComponent,
    AnalytehealthLayoutComponent,
  ],
})
export class SiteLayoutComponent {
  /** Loading status */
  public isLoading: boolean = false;
  public sites = Sites;

  private loadingService = inject(LoadingService);

  public constructor() {
    this.loadingService.loading$.subscribe((loadingStatus) => (this.isLoading = loadingStatus));
  }

  /**
   * Gets the current site.
   */
  public get site(): Sites {
    return environment.site as Sites;
  }
}
